import Axios from 'axios'

const checkPost = (url, body, headers) => Axios.post(url, body, {
  headers,
})

export default {
  checkPost,
}
